<template>
  <gj-modal
      size="700XAuto"
      :visible.sync="modalVisible"
      @cancel="$emit('cancel')"
      @confirm="$emit('confirm')">
    <template #header>
      <span>应用确认</span>
    </template>
    <template #content>
      <div>
        <gj-alert type="warning" show-icon>
          <template #title>
            <div>已添加可能同时命中规则，请确定是否继续添加？</div>
          </template>
        </gj-alert>
        <div style="height: 250px; margin-top: 12px">
          <gj-table
              ref="gjTable"
              :index="false"
              :data="tableData"
              adaptParent
              :loading="loading"
              :columns="tableColumns"
          >
            <template #applyObjectAdsType="{row}">
              <div>{{ objectAdsType[row.applyObjectAdsType] }}</div>
              <div>{{ row.applyObjectName }}</div>
            </template>
            <template #ruleText="{row}">
              <gj-text>
                {{ row.ruleText }}
              </gj-text>
            </template>
          </gj-table>
        </div>
      </div>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn} from "@/minxins";
import { objectAdsType } from './config'
import { getRuleContent } from '../const'
  export default {
    mixins: [modalMixIn],
    props: {
      sameData: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        objectAdsType,
        tableData: this.sameData.map(item => {
          item.ruleText = getRuleContent(item.templateDetailVO.expressionVO);
          return item;
        }),
        tableColumns: [
            { id: 'applyObjectAdsType', header: '应用对象', field: 'slot:applyObjectAdsType', width: '200px' },
            { id: 'executeObjectAdsType', header: '优化对象', field: 'executeObjectAdsType', width: '100px' },
            { id: 'name', header: '模板名称', field: 'name', width: '100px' },
            { id: 'ruleText', header: '规则', field: 'slot:ruleText', minWidth: '100px' },
        ],
        loading: false 
      }
    },
    methods: {
        
    }
  }
</script>

<style lang="scss" scoped>

</style>
